import { render, staticRenderFns } from "./TranscriptDetails.vue?vue&type=template&id=1cb2e8d2&scoped=true"
import script from "./TranscriptDetails.vue?vue&type=script&lang=js"
export * from "./TranscriptDetails.vue?vue&type=script&lang=js"
import style0 from "./TranscriptDetails.vue?vue&type=style&index=0&id=1cb2e8d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb2e8d2",
  null
  
)

export default component.exports